export default "__VITE_ASSET__CB5O34mg__"